<template>
	<div id="register">
		<!-- <router-view></router-view> -->
		<div class="container">
			<div class="loginContainer">
				<!-- <div class="left">
					<div class="leftTitle">
						Hi，欢迎使用校招校招平台
					</div>
					<div class="imgContainer">
						<img src="" alt="" />
					</div>
				</div> -->
				<!-- :style="channel?'':'height: 749px;'" -->
				<img class="left"
					src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/31/posaysyatwqq.png" alt="" />
					<!-- :style="channel?'':'height: 749px;'" -->
					
				<div class="right" >
					<div class="title">注册账号</div>
					<div class="nameContainer">
						<div class="text">手机号码：</div>
						<el-input v-model="user_data.tel" :disabled="true" placeholder="请输入手机号码"></el-input>
					</div>
					<div class="nameContainer">
						<div class="text"><span style="color:#FF4A4A">*</span>账号密码：</div>
						<el-input placeholder="请输入密码（不少于4位数）" v-model="pwd1" show-password></el-input>
					</div>
					<div class="nameContainer">
						<div class="text"><span style="color:#FF4A4A">*</span>重复密码：</div>
						<el-input placeholder="请确认密码（不少于4位数）" v-model="pwd2" show-password></el-input>
					</div>
					<div class="avatarContainer">
						<div class="text"><span style="color:#FF4A4A">*</span>我的头像：</div>
						<div class="uploadContainer">
							<div class="upload">
								<el-tooltip class="item" effect="dark" content="点击上传/更换图片" placement="right">
									<el-upload :headers="headers" class="avatar-uploader"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<img v-if="newAvatar" :src="newAvatar" class="avatar" />
										<div class="avatarUploader" v-else>
											<i class="el-icon-plus avatar-uploader-icon"></i>
											<span style="font-size: 12px">点击上传</span>
										</div>
									</el-upload>
								</el-tooltip>
							</div>
							<div class="uploadText">建议尺寸1:1，JPG、PNG格式， 图片小于 5M。</div>
						</div>
					</div>

					<div class="nameContainer">
						<div class="text"><span style="color:#FF4A4A">*</span>我的姓名：</div>
						<el-input v-model="realName" placeholder="请输入姓名"></el-input>
					</div>

					<div class="companyContainer">
						<div class="text"><span style="color:#FF4A4A">*</span>我的公司：</div>

						<div class="company">
							<div class="top">
								<!-- <el-input v-model="searchName" placeholder="请输入您所属公司营业执照上的公司名称"></el-input> -->

								<!-- <el-select style="flex: 1" size="medium" v-model="searchName" filterable placeholder="请输入公司名称">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select> -->
								<el-select @change="handleChange" style="flex: 1" size="medium" v-model="searchName"
									allow-create filterable remote reserve-keyword placeholder="请输入公司名称"
									:remote-method="remoteMethod" :loading="loading">
									<el-option v-for="(item,index) in options" :key="index" :label="item.label"
										:value="item.label"> </el-option>
								</el-select>
								<div class="uplodadCompany1">
									<el-upload class="avatar-uploader1"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess1"
										:before-upload="beforeAvatarUpload1">
										<div class="uplodadCompany">
											<img @click="openUpload(0)" style="width: 22px; height: 17px"
												src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/05/sswknvbhcazwpwee.png"
												alt="" />
											<div @click="openUpload(0)" class=""
												style="font-size: 14px;margin-right: 5px;">上传营业执照</div>

											<img @click="openUpload(1)" style="width: 22px; height: 17px"
												src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/05/sswknvbhcazwpwee.png"
												alt="" />
											<div @click="openUpload(1)" class="" style="font-size: 14px">上传非营业执照</div>
										</div>
									</el-upload>
								</div>
							</div>
							<div class="companyImg">
								<img class="card" v-if="business_license_url" :src="business_license_url" alt="" />
								<img class="card" v-else
									src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/05/lisnbsqur1xwhu9g.png"
									alt="" />

								<div class="">
									<span class="c-p" style="margin-bottom: 5px">注意事项: </span>
									<span class="c-p" style="margin-bottom: 5px">1.请输入您所属公司营业执照上的公司名称</span>
									<span class="c-p" style="margin-bottom: 5px">2.请注意区分总公司和分公司</span>
									<span class="c-p" style="margin-bottom: 5px">3.公司名称将用于后续的企业认证使用，请确保准确性</span>
									<span class="c-p" style="line-height:16px;">4.请您正确上传营业执照，照片需横向摆放，请勿竖放，确保证件完整、清晰、无遮挡、无倒置，以便顺利审核。</span>
								</div>
							</div>
						</div>
					</div>

					<div class="nameContainer" style="margin-top: 12px">
						<div class="text"><span style="color:#FF4A4A">*</span>我的职位：</div>
						<el-input v-model="position" maxlength="10" placeholder="输入真实的职务，更能赢得信任"></el-input>
					</div>
					<div class="nameContainer" style="margin-top: 12px" >
						<div class="text"><span style="color:#FF4A4A">*</span>我的邮箱：</div>
						<el-input v-model="email" placeholder="请输入企业接收简历的邮箱"></el-input>
					</div>
					<!-- <div class="nameContainer" style="margin-top: 12px" v-if="!channel">
						<div class="text">邀请码：</div>
						<el-input v-model="channelCode" placeholder="输入邀请码"></el-input>
					</div> -->

					<div class="btn">
						<div class="" @click="submit">注册</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { trim } from 'jquery'
import {
		mapMutations,
		mapState,
		mapActions
	} from 'vuex'
	// import { getAcademyList, getAllCompanyList, checkCompany, saveCompanyUserInfo } from '@/api/job.js'
	// import { schoolGetmajordetail, getNewKySchoolList, getDepartBysid, getMajorByDid, picRead, getComChatList, getComChatList1 } from '@/api/studentv2.js'
	export default {
		data() {
			return {
				loading: false,
				searchName: '',
				options: [],
				checked: false,

				isQrcode: false,

				newAvatar: '',
				business_license_url: '',
				headers: {},
				realName: '',
				pwd1: '',
				pwd2: '',
				position: '',
				user_data: {
					tel: '',
				},
				showActionSheetIndex: 0,
				
				channel:null,
				
				channelCode:'',
				email:'',
				timer:null
			}
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userinfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
				admin_id: state => state.schoolData,
			}),
			// hasLogin() {
			//   return this.$store.getters.nextToken
			// },
			// userinfo() {
			//   return this.$store.getters.userinfo
			// },
			// adminId() {
			//   return this.$store.getters.adminId
			// },

		},
		watch: {},
		mounted() {
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );

			// 输出: false
			if (this.isJSONString(this.userinfo)) {
				this.user_data = JSON.parse(this.userinfo)
			} else {
				this.user_data = this.userinfo
			}
			
			if (this.$route.query.channel) {
				this.channel = this.$route.query.channel
				console.log(this.channel)
			}
			
		},
		methods: {
			...mapMutations(['setIslogin', 'setAdminId', 'setUserInfo', 'setUserId']),
			...mapActions(['getUserInfo', 'getCompanyUserInfo']),
			isJSONString(str) {
				try {
					JSON.parse(str)
					return true
				} catch (e) {
					return false
				}
			},
			updateUserStatus(admin_id){
				this.$util.post(
					"job/im/updateUserStatus", {
						userId:admin_id,
						platform:3,
						userType:1,
						onlineStatus:1,
					},
					(res) => {
						
					}
				);
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true


					// setTimeout(() => {
					this.$util.post(
						"v2/school_job/getAllCompanyList", {
							keyword: query,
							page: 1,
							size: 10,
						},
						(res) => {
							if (res.code === 200) {
								if (res.data.data) {
									this.options = res.data.data.map((item) => {
										return {
											value: item.admin_id,
											label: item.company_name,
										}
									})
								} else {
									this.options = []
								}
								this.loading = false
							}
						},(err)=>{
						console.log(err)
						this.loading = false
					}
					);
					// getAllCompanyList(1, 10, query).then((res) => {
					//   if (res.code === 200) {
					//     if (res.data.data) {
					//       this.options = res.data.data.map((item) => {
					//         return {
					//           value: item.admin_id,
					//           label: item.company_name,
					//         }
					//       })
					//     } else {
					//       this.options = []
					//     }
					//     this.loading = false
					//   }
					// })

					// this.loading = false;
					// this.options = this.list.filter(item => {
					//   return item.label.toLowerCase()
					//     .indexOf(query.toLowerCase()) > -1;
					// });
					// }, 200)
				} else {
					this.options = []
				}
			},
			isRequest(duration = 4000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			login() {
				this.setIslogin(true)
				this.$router.push({
					path: '/',
					// query: {
					//   id: 1,
					// },
				})
			},
			openUpload(type) {
				this.showActionSheetIndex = type
			},
			// isDebounce(duration = 500) {
			// 	return new Promise(resolve => {
			// 		// 如果已有定时器，清除（重新计时）
			// 		if (this.timer) {
			// 			clearTimeout(this.timer);
			// 		}
			// 		// 开启新定时器
			// 		this.timer = setTimeout(() => {
			// 			resolve(); // 时间到 → 放行
			// 		}, duration);
			// 	});
			// },
			async submit() {
				if (this.isRequest()) return false
				// his.user_data.user_id
				
				if (!this.pwd1) {
					this.$message.error('请输入账号密码')
					return
				}
				let reg = /\s/
				if (reg.test(this.pwd1)) {
					this.$message.error('密码不能含有空格');
					return
				}
				if (this.pwd1.length < 4) {
					this.$message.error('密码长度不能小于4位');
					return
				}
				if (this.pwd1 !== this.pwd2) {
					this.$message.error('账号密码和重复密码不一致，请重新输入')
					return
				}
				// if (!this.company_name) {
				//   this.$message.error('请输入您的就职公司')
				//   return
				// }
				if (!this.newAvatar) {
					this.$message.error('请上传您的头像')
					return
				}
                this.realName = this.realName.trim()
                if (!this.realName) {
                	this.$message.error('请输入您的姓名')
                	return
                }
                
                this.searchName = this.searchName.trim()
				if (!this.searchName) {
					this.$message.error('请输入公司名称')
					return
				}
				
				if (!this.business_license_url && this.searchName !== '武汉升学在线国际旅游有限公司') {
					this.$message.error('请上传公司有效证件')
					return
				}
				this.position = this.position.trim()
				if (!this.position) {
					this.$message.error('请输入您的职位')
					return
				}
				if(!this.email){
					this.$message.error('请输入您的邮箱')
                    return
                }
				// yi.he@innovi.net.cn
				// sx985@sx985.com
				let email = this.email.trim()
                const regex =  /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i
               if(!regex.test(email)){
				   this.$message.error('请输入正确格式的邮箱')
                   return
               }

				if (this.showActionSheetIndex == 0) {
					// if(this.biz_license_company_name !== this.searchName && this.searchName !=='武汉升学在线国际旅游有限公司'){
					//     this.$message.error("营业执照名称与输入公司名称不一致，请重新上传营业执照")
					//     return
					// }
					this.$util.post(
						"v2/school_job/checkCompany", {
							company_name: this.searchName,
						},
						(res) => {
							if (res.code === 0) {
								// localStorage.setItem('admin_id', res.data.admin_id)
								this.setAdminId(res.data.admin_id)
								this.setUserId(this.user_data.id)
								// this.$store.commit('setAdminId', res.data.admin_id)
								if (res.data.is_register === 0) {
									//创建公司
									this.$util.post(
										"v2/school_job/editCompany", {
											logo: '',
											admin_id: res.data.admin_id || 0,
											company_name: this.searchName,
											// business_license_url:this.business_license_url,
											// email:this.email.trim(),
										},
										(result) => {
											if (result.code === 0) {
												// this.getCompanyInfo(res.data.admin_id)
												this.saveHrInfo(res.data.admin_id)
											}
										}
									);
								} else {
									//已有
									this.getCompanyInfo(res.data.admin_id)
									this.saveHrInfo(res.data.admin_id)
								}
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 1000
								});
							}
						})
					// checkCompany(this.searchName).then((res) => {
					// 	if (res.code === 0) {
					// 		localStorage.setItem('admin_id', res.data.admin_id)
					// 		this.$store.commit('setAdminId', res.data.admin_id)
					// 		if (res.data.is_register === 0) {
					// 			//创建公司
					// 		} else {
					// 			//已有
					// 		}
					// 		this.saveHrInfo()
					// 	}
					// })
				} else {
					let obj = {
						imagePath: this.business_license_url, //url
						cname: this.searchName,
					}
					this.$util.post(
						"v2/getOtherCert", {
							...obj,
						},
						(res2) => {
							if (res2.code === 200) {
								if (res2.data.result.length == 0) {
									// this.business_license_url = ''
									// this.$message.error('')
									this.$message({
										message: '未识别出有效证件信息，请重新上传有效证件',
										type: 'error',
										duration: 2000
									});
									return
								}

								if (!res2.data.company_site) {
									// this.$message.error('检测到您证件上面的公司名称与填写的不一致，请按照证件上的公司名称填写！')
									this.$message({
										message: '检测到您证件上面的公司名称与填写的不一致，请按照证件上的公司名称填写！',
										type: 'error',
										duration: 2000
									});
									return
								}
								this.$util.post(
									"v2/school_job/checkCompany", {
										company_name: this.searchName,
									},
									(res) => {
										if (res.code === 0) {
											this.setAdminId(res.data.admin_id)
											this.setUserId(this.user_data.id)
											if (res.data.is_register === 0) {
												// 创建公司
												this.$util.post(
													"v2/school_job/editCompany", {
														logo: '',
														admin_id: res.data.admin_id || 0,
														company_name: this.searchName,
														business_license_url:this.business_license_url,
														email:this.email.trim(),
													},
													(result) => {
														if (result.code === 0) {
															// this.getCompanyInfo(res.data.admin_id)
															this.saveHrInfo(res.data.admin_id)
														}
													}
												);
											} else {
												// 已有公司
												this.getCompanyInfo(res.data.admin_id)
												this.saveHrInfo(res.data.admin_id)
											}
										} else {
											this.$message({
												message: res.msg,
												type: 'error',
												duration: 2000
											});
										}

									})
								// checkCompany(this.searchName).then((res) => {
								// 	if (res.code === 0) {
								// 		localStorage.setItem('admin_id', res.data.admin_id)
								// 		this.$store.commit('setAdminId', res.data.admin_id)
								// 		if (res.data.is_register === 0) {
								// 			// 创建公司
								// 		} else {
								// 			// 已有公司
								// 		}
								// 		this.saveHrInfo()
								// 	}
								// })
								// prevPage.$vm.showActionSheetIndex = this.showActionSheetIndex
							} else {
								this.$message.error(res2.msg)
								localStorage.setItem('license', '')
								this.business_license_url = ''
							}
						}
					);
					// getComChatList1(obj).then((res2) => {

					// })
				}

				// let aobj = {
				//   logo: this.companyLogo || '',
				//   admin_id: this.adminId || 0,
				//   id: this.c_id || 0,
				//   // scale: this.scales.scale,
				//   // scale_min: this.scales.scale_min,
				//   // scale_max: this.scales.scale_max,
				//   company_name: this.searchName,
				//   financing_situation: '',
				//   industry: this.industry,
				//   business_license_url: this.business_license_url,
				// }
				// 
				// this.$router.push({
				//   path: '/home',
				//   // query: {
				//   //   id: 1,
				//   // },
				// })
			},
			getCompanyInfo(adminId) {
				if (!adminId) {
					return
				}
				this.$util.post(
					"v2/school_job/getCompanyInfo", {
						admin_id: adminId
					},
					(res) => {
						if (res.code === 200) {
							if (res.data.job_title && res.data.job_title[0]) {
								localStorage.setItem('job_title', JSON.stringify(res.data.job_title))
								this.jobs = {
									job_title: JSON.stringify(res.data.job_title),
								}
							} else {
								localStorage.setItem('job_title', '')
							}

							this.$store.commit('setSchoolData', res.data)
							localStorage.setItem('schoolData', JSON.stringify(res.data))
							
							this.$util.post(
								"v2/school_job/editCompany", {
									admin_id: res.data.admin_id,
									id: res.data.id,
									email:this.email.trim(),
									business_license_url:this.business_license_url
								},
								(res) => {
							
								})
						}

					}
				);
				//   getCompanyInfo(adminId).then((res) => {
				//     if (res.code === 200) {
				//       if (res.data.job_title && res.data.job_title[0]) {
				//         localStorage.setItem('job_title', JSON.stringify(res.data.job_title))
				//         this.jobs = {
				//           job_title: JSON.stringify(res.data.job_title),
				//         }
				//       } else {
				//         localStorage.setItem('job_title', '')
				//       }

				//       this.$store.commit('setSchoolData', res.data)
				//       localStorage.setItem('schoolData', JSON.stringify(res.data))
				//     }
				//   })
			},
			saveHrInfo(admin_id) {
				let salesmanPhone = localStorage.getItem('salesmanPhone')
				
                
				let obj = {
					id: 0,
					username: this.realName,
					position: this.position,
					avatar: this.newAvatar,
					user_id: this.user_data.id,
					admin_id: admin_id,
					// business_tel: this.user_data.tel,
					tel: this.user_data.tel,
					password: this.pwd1,
					business_tel:salesmanPhone||this.channelCode,
					
					email:this.email.trim()
				}
				
				this.$util.post(
					"v2/school_job/saveCompanyUserInfo", {
						...obj
					},
					(res) => {
						if (res.code === 0) {
							this.getCompanyUserInfo()
							this.getCompanyInfo(admin_id)
							this.$message({
								message: '注册成功',
								type: 'success',
								duration: 1000
							});
							this.updateUserStatus(admin_id)
							
							setTimeout(() => {
								this.$router.push({
									path: '/home',
								})
							}, 1000)
							
						} else {
							this.$message.error(res.msg)
						}
					})

			},
			handleChange(e) {
				if (typeof e === 'number') {
					//有公司
					localStorage.setItem('admin_id', e)
					this.$store.commit('setAdminId', e)
				} else {
					this.searchName = e
					//创建公司
				}
			},
			handleAvatarSuccess(res) {
				this.newAvatar = res.data.fileUrl
			},
			handleAvatarSuccess1(res) {
				this.business_license_url = res.data.fileUrl
				if (this.showActionSheetIndex == 0) {
					this.add_photo(res.data.fileUrl)
				} else {
					this.add_photo1(res.data.fileUrl)
				}
			},

			add_photo(datas) {
				// if (this.business_license_url && type === 2) {
				// 	wx.previewImage({
				// 		current: this.business_license_url, // 当前显示图片的http链接
				// 		urls: [this.business_license_url], // 需要预览的图片http链接列表
				// 		loop: true
				// 	})
				// 	return
				// }

				this.$util.post(
					"v2/getChatList", {
						// ...datas
						imagePath: datas
					},
					(res2) => {
						if (res2.code === 200) {
							if (res2.data.biz_license_company_name === '无') {
								this.business_license_url = ''
								this.$message.error('未识别出营业执照信息，请重新上传营业执照')
								return
							}
							if (res2.data.biz_license_company_name !== this.searchName && this.searchName) {
								this.$message.error('检测到您营业执照上面的名称与填写的不一致，将以营业执照上的名称为准！')
							}

							this.business_license_url = datas
							this.searchName = res2.data.biz_license_company_name || ''
							this.biz_license_company_name = res2.data.biz_license_company_name || ''
							res2.data.business_license_url = this.business_license_url
							localStorage.setItem('license', res2.data)
						} else {
							if(res2.msg=='数据返回为空'){
								this.$message.error('未识别出营业执照信息，请重新上传营业执照')
							}else{
								this.$message.error(res2.msg)
							}
							localStorage.setItem('license', '')
							this.business_license_url = ''
						}
					}
				);
				// getComChatList(datas).then((res2) => {
				// 	if (res2.code === 200) {
				// 		if (res2.data.biz_license_company_name === '无') {
				// 			this.business_license_url = ''
				// 			this.$message.error('未识别出营业执照信息，请重新上传营业执照')
				// 			return
				// 		}
				// 		if (res2.data.biz_license_company_name !== this.searchName && this.searchName) {
				// 			this.$message.error('检测到您营业执照上面的名称与填写的不一致，将以营业执照上的名称为准！')
				// 		}

				// 		this.business_license_url = datas
				// 		this.searchName = res2.data.biz_license_company_name || ''
				// 		this.biz_license_company_name = res2.data.biz_license_company_name || ''
				// 		res2.data.business_license_url = this.business_license_url
				// 		localStorage.setItem('license', res2.data)
				// 	} else {
				// 		this.$message.error(res2.msg)
				// 		localStorage.setItem('license', '')
				// 		this.business_license_url = ''
				// 	}
				// })
			},

			add_photo1(url) {
				this.business_license_url = url
			},

			beforeAvatarUpload1(file) {
				
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					return
				}
				
				return isLt2M && img;

			},
			beforeAvatarUpload(file) {
				
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return false
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}
				
				return isLt2M && img;
			},

		},
		components: {},
	}
</script>
<style></style>
<style lang="less" scoped>
	#Login {}

	.container {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		// background: url(https://new-shengxue985-test.oss-cn-hangzhou.aliyuncs.com/sxzx/2021/3/pic/16c3b44183f34011a10909b690f1869a.png);
		background: #4290f1;
	}

	.loginContainer {
		display: flex;
		font-size: 0;
		align-items: center;

		.left {
			width: auto;
			height: 750px;
			display: block;
			min-width: 345px;
			// padding: 52px 25px;
			// background: #DEECFF;
			// background: url(https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/05/ncgg4kepshbvkzdk.png) no-repeat;
			// background-size: 100% 100%;

			// .leftTitle {
			// 	font-weight: bold;
			// 	font-size: 33px;
			// 	color: #3B221A;
			// 	margin-bottom: 146px;
			// 	border-radius: 10px 0 0 10px;
			// }

			// .imgContainer {
			// 	width: 100%;
			// 	display: flex;
			// 	font-size: 0;
			// 	justify-content: center;

			// 	img {
			// 		width: 317px;
			// 		height: 274px;
			// 		background: #fff;
			// 	}
			// }
		}

		.right {
			width: 766px;
			height: 750px;
			background: #fff;
			border-radius: 0 10px 10px 0;
			// display: flex;
			// align-items: center;
			// justify-content: center;
			box-sizing: border-box;
			padding: 30px 50px 30px 25px;

			.title {
				font-weight: 600;
				font-size: 24px;
				color: #333333;
				margin-bottom: 14px;
			}

			.avatarContainer {
				display: flex;
				// align-items: center;
				margin-bottom: 24px;

				.text {
					width: 100px;
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: 16px;
					color: #333333;
					margin-right: 20px;
				}

				.upload {
					margin-right: 20px;
				}

				.uploadContainer {
					display: flex;
					align-items: center;

					.uploadText {
						width: 360px;
						font-weight: 400;
						font-size: 14px;
						color: #999999;
					}
				}
			}

			.nameContainer {
				display: flex;
				align-items: center;
				margin-bottom: 12px;

				.text {
					width: 100px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					margin-right: 20px;
				}

				.el-input {
					flex: 1 !important;
				}
			}

			.companyContainer {
				display: flex;
				align-items: center;

				.text {
					width: 100px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					margin-right: 20px;
				}

				.el-input {
					flex: 1 !important;
				}

				.company {
					flex: 1;
					background: #ffffff;
					border-radius: 5px;
					border: 1px solid #dcdcdc;
					box-sizing: border-box;
					padding: 0 15px;

					.top {
						display: flex;
						align-items: center;
						width: 100%;
						border-bottom: 1px solid #dcdcdc;
						margin-bottom: 15px;

						// padding:  0 5px;
						.uplodadCompany1 {}

						.uplodadCompany {
							display: flex;
							align-items: center;
							font-size: 0;
							margin-left: 10px;

							img {
								width: 20px;
								height: 20px;
								margin-right: 2px;
								margin-left: 6px;
							}

							div {
								font-weight: 500;
								font-size: 16px;
								color: #3a84e9;
							}
						}
					}

					.companyImg {
						display: flex;
						align-items: center;
						// padding: 0 15px;
						padding-bottom: 15px;
						font-size: 0;

						.card {
							width: 194px;
							height: 116px;
							margin-right: 15px;
						}

						div {
							display: flex;
							// align-items: center;
							justify-content: space-between;
							flex-direction: column;

							.c-p {
								font-size: 12px;
								color: #84868a;
								font-weight: 400;
							}
						}
					}
				}
			}
		}
	}

	.btn {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		cursor: pointer;

		div {
			width: 134px;
			height: 45px;
			background: #1E40AF;
			border-radius: 10px;

			text-align: center;
			line-height: 45px;

			font-weight: 500;
			font-size: 16px;
			color: #ffffff;
		}
	}
</style>

<style>
	#register .el-input__inner {
		font-size: 14px;
	}

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
		height: 36px !important;
		line-height: 36px !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #e5e5e5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #f5f7fa;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	#register .avatarUploader {
		width: 62px !important;
		height: 62px !important;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	/* .avatar {
		width: 178px;
		height: 178px;
		display: block;
	} */
	#register .avatar-uploader1 .el-upload {
		border: none;
	}

	#register .avatar-uploader1 .el-upload {
		/* border: 1px solid #E5E5E5; */
		/* border-radius: 50%; */
		cursor: pointer;
		position: relative;
		overflow: hidden;
		/* background: #F5F7FA; */

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	#register .avatar-uploader1 .el-upload:hover {
		border-color: #409eff;
	}

	.avatarUploader1 {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	#register .avatar-uploader1 span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	#register .avatar {
		width: 62px !important;
		height: 62px !important;
		display: block !important;
	}
</style>
